<template>
  <div class="document-type-list-item-component" v-bind:class="{selected, loading}" v-on:click="onClick">
    <a-spin v-if="loading && !selected" style="margin-left: -5px; margin-right: 5px;">
      <a-icon slot="indicator" type="loading" style="font-size: 18px" spin/>
    </a-spin>
    <span class="faded">{{ documentTypeCode }}</span> {{ documentTypeName }}
  </div>
</template>

<script>

export default {
  name: 'DocumentTypeListItemComponent',
  components: {},
  props: {
    documentType: {
      required: true,
      type: Object
    },
    documentCodeType: {
      required: false,
      type: String,
      default: 'hdn'
    },
    selected: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
  },
  computed: {
    documentTypeCode () {
      return this.documentCodeType === 'hdn'
          ? this.documentType.hdn_document_type
          : this.documentType.sivi_document_type
    },
    documentTypeName () {
      return this.documentType.name
    },
  },
  methods: {
    onClick () {
      if (!this.selected && !this.loading) {
        this.loading = true
        this.$emit('click', this.documentType, this);
      }
    },
  }
}
</script>
<style scoped>
.document-type-list-item-component {
  padding: 8px 16px;
  border-bottom: 1px solid #e8e8e8;
}

.document-type-list-item-component.loading {

}

.document-type-list-item-component.selected {
  background-color: #e8e8e8;
  opacity: 0.5;
  cursor: default;
}

.document-type-list-item-component .faded {
  opacity: 0.4;
  font-family: monospace;
  margin-right: 10px;
}

.document-type-list-item-component:last-child {
  border-bottom: none;
}

.document-type-list-item-component:not(.selected):hover {
  background-color: #ececec;
  cursor: pointer;
}
</style>
